var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticClass: "multi-select",
      attrs: {
        multiple: "",
        filterable: "",
        size: "mini",
        "collapse-tags": "",
        placeholder: _vm.placeholder,
      },
      on: { change: _vm.selectRateChange },
      model: {
        value: _vm.selectItems,
        callback: function ($$v) {
          _vm.selectItems = $$v
        },
        expression: "selectItems",
      },
    },
    [
      _c("el-option", { attrs: { label: "全选", value: "ALL" } }),
      _vm._l(_vm.items, function (opt) {
        return _c("el-option", {
          key: opt.value,
          attrs: { label: opt.name, value: opt.value },
        })
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }